module.exports = __webpack_public_path__ + "static/media/rotatingStars.eaca8c4e.gif";